import React from 'react';

export const parseMetadata = (metadata) => {
    const meta = 'string' === typeof metadata
        ? (() => { try { return JSON.parse(metadata); } catch { return metadata; } })()
        : metadata;

    if (!meta || (Array.isArray(meta) && 0 === meta.length)) {
        return null;
    }

    return meta;
};

export const formatObjectKeyValue = (obj) => {
    if (null === obj || undefined === obj) {
        return '';
    }

    if (Array.isArray(obj)) {
        return obj.map(item => formatObjectKeyValue(item)).join(', ');
    }

    if ('object' === typeof obj) {
        return Object.entries(obj)
            .map(([key, value]) => `${key}: ${formatObjectKeyValue(value)}`)
            .join(', ');
    }

    return String(obj);
};

export const metadataToSortableString = (metadata) => {
    const meta = parseMetadata(metadata);

    if (null === meta) {
        return '';
    }

    return formatObjectKeyValue(meta);
};

export const jobHistoryColumns = {
    'ts': {
        label: 'Date/time',
        sorting: true,
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'state': {
        label: 'Status',
        sorting: true,
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
};

export const jobHistoryRowRenderer = (column, row) => {
    switch (column) {
        case 'ts':
            return row.ts || '-';
        case 'state':
            return row.state || '-';
        default:
            return null;
    }
};

export const streamHistoryColumns = {
    'ts': {
        label: 'Date/time',
        sorting: true,
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
            singleLine: true,
        },
    },
    'type': {
        label: 'Event Type',
        sorting: true,
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
    'metadata': {
        label: 'Metadata',
        sorting: row => metadataToSortableString(row.metadata),
        header: {
            align: 'left',
        },
        content: {
            align: 'left',
        },
    },
};

export const streamHistoryRowRenderer = (column, row) => {
    switch (column) {
        case 'ts':
            return row.ts || '-';
        case 'type':
            return row.type || '-';
        case 'metadata': {
            const meta = parseMetadata(row.metadata);

            if (null === meta) {
                return null;
            }

            if ('object' === typeof meta && !Array.isArray(meta)) {
                const lines = Object.entries(meta).map(([k, v]) => `${k}: ${formatObjectKeyValue(v)}`);

                return (
                    <span>
                        {lines.map((line, i) => (
                            <React.Fragment key={line}>
                                {0 < i && <br/>}
                                {line}
                            </React.Fragment>
                        ))}
                    </span>
                );
            }

            return String(meta);
        }
        default:
            return null;
    }
};
